import { render, staticRenderFns } from "./IssueStatusTableCell.vue?vue&type=template&id=f59186e0&scoped=true"
import script from "./IssueStatusTableCell.vue?vue&type=script&lang=js"
export * from "./IssueStatusTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueStatusTableCell.vue?vue&type=style&index=0&id=f59186e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59186e0",
  null
  
)

export default component.exports